import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthGuard = ({ children, requireRole }) => {
    const { isLoggedIn, isLoading, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-transparent z-50">
                <Loader2 className="w-8 h-8 text-accent-primary animate-spin" />
            </div>
        );
    }

    if (!isLoggedIn) {
        // Redirect to login page and save the attempted URL
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireRole) {
        const roles = ['user', 'moderator', 'premium', 'admin'];
        const userRoleLevel = roles.indexOf(user?.role || 'user');
        const requiredRoleLevel = roles.indexOf(requireRole);
        
        if (userRoleLevel < requiredRoleLevel) {
            return (
                <div className="flex flex-col items-center justify-center p-10 h-full text-center">
                    <h2 className="text-xl font-bold text-red-500 mb-2">Access Denied</h2>
                    <p className="text-white/60">You need {requireRole} privileges to view this section.</p>
                </div>
            );
        }
    }

    return children;
};

export default AuthGuard;
